import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "ion-text-wrap"
}
const _hoisted_3 = { class: "media-tab-wrap" }
const _hoisted_4 = { class: "media-tab-panel" }
const _hoisted_5 = { class: "media-tab-panel" }
const _hoisted_6 = {
  key: 0,
  class: "file-info"
}
const _hoisted_7 = {
  key: 0,
  class: "file-too-big"
}
const _hoisted_8 = { class: "pdf-row-end" }
const _hoisted_9 = { class: "pdf-actions" }
const _hoisted_10 = {
  key: 1,
  class: "empty-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_AdminVideoUpload = _resolveComponent("AdminVideoUpload")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Загрузка медиатеки",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card disk-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("Место на сервере", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  (_ctx.diskSpace)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Свободно: " + _toDisplayString(_ctx.formatBytes(_ctx.diskSpace.availableBytes)) + " из " + _toDisplayString(_ctx.formatBytes(_ctx.diskSpace.totalBytes)), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_2, "Загрузка данных о месте…"))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Раздел медиатеки", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_select, {
                        label: "Главный раздел",
                        "label-placement": "stacked",
                        modelValue: _ctx.selectedMediaCategory,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMediaCategory) = $event)),
                        interface: "popover",
                        mode: "ios",
                        placeholder: "Выберите раздел",
                        onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMediaCategoryChange()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaCategories, (category) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: category.key,
                              value: category.key
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(category.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ion_segment, {
              value: _ctx.mediaTab,
              onIonChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMediaTabChange($event))),
              mode: "ios",
              class: "media-tab-segment"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, { value: "video" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("Видео", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "pdf" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("PDF материалы", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AdminVideoUpload, {
              "embed-mode": "",
              "media-category": _ctx.selectedMediaCategory
            }, null, 8, ["media-category"])
          ], 512), [
            [_vShow, _ctx.mediaTab === 'video']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ion_card, { class: "admin-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Загрузить PDF", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          label: "Подраздел медиатеки",
                          "label-placement": "stacked",
                          modelValue: _ctx.pdfUploadSectionKey,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pdfUploadSectionKey) = $event)),
                          interface: "popover",
                          mode: "ios",
                          placeholder: "Выберите раздел"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSections, (s) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: s.id || s.folderKey,
                                value: s.folderKey
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(s.name) + " (" + _toDisplayString(s.folderKey) + ")", 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Название для пользователей",
                          "label-placement": "stacked",
                          modelValue: _ctx.pdfUploadDisplayName,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pdfUploadDisplayName) = $event)),
                          placeholder: "Отображаемое название материала"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createElementVNode("input", {
                          type: "file",
                          ref: "pdfFileInput",
                          accept: ".pdf,application/pdf",
                          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPdfFileSelected && _ctx.onPdfFileSelected(...args)))
                        }, null, 544)
                      ]),
                      _: 1
                    }),
                    (_ctx.selectedPdfFile)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                          _createTextVNode(" Файл: " + _toDisplayString(_ctx.selectedPdfFile.name) + " (" + _toDisplayString(_ctx.formatBytes(_ctx.selectedPdfFile.size)) + ") ", 1),
                          (!_ctx.isPdfExtension(_ctx.selectedPdfFile.name))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " — допустимы только файлы .pdf"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doPdfUpload())),
                      disabled: !_ctx.canPdfUpload || _ctx.pdfUploadInProgress
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.pdfUploadInProgress ? 'Загрузка…' : 'Загрузить PDF'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card, { class: "admin-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("PDF материалы раздела «" + _toDisplayString(_ctx.mediaCategoryTitle) + "»", 1)
                      ]),
                      _: 1
                    }),
                    _cache[14] || (_cache[14] = _createElementVNode("p", { class: "admin-card-download-hint" }, "Переключатель «Скачивание» разрешает или запрещает пользователям скачивать файл к себе.", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          label: "Раздел",
                          "label-placement": "stacked",
                          modelValue: _ctx.filterPdfSectionKey,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterPdfSectionKey) = $event)),
                          interface: "popover",
                          mode: "ios",
                          onIonChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadPdfs()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "" }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("Все разделы", -1)
                              ]))]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSections, (s) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: s.id || s.folderKey,
                                value: s.folderKey
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(s.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.pdfs.length)
                      ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pdfs, (p) => {
                              return (_openBlock(), _createBlock(_component_ion_item, {
                                key: p.id,
                                class: "pdf-row"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", null, _toDisplayString(p.displayName), 1),
                                      _createElementVNode("p", null, _toDisplayString(p.sectionName || p.sectionFolderKey) + " · " + _toDisplayString(_ctx.formatBytes(p.fileSizeBytes || 0)), 1),
                                      _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_ion_toggle, {
                                          checked: !!p.allowDownload,
                                          onIonChange: ($event: any) => (_ctx.onPdfAllowDownloadChange(p, $event)),
                                          "aria-label": "Скачивание",
                                          title: "Разрешить скачивание пользователям"
                                        }, null, 8, ["checked", "onIonChange"]),
                                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "pdf-toggle-label" }, "Скачивание", -1)),
                                        _createElementVNode("div", _hoisted_9, [
                                          _createVNode(_component_ion_button, {
                                            fill: "clear",
                                            color: "medium",
                                            size: "small",
                                            onClick: ($event: any) => (_ctx.renamePdf(p)),
                                            title: "Переименовать"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "icon-only",
                                                icon: _ctx.pencilOutline
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]),
                                          _createVNode(_component_ion_button, {
                                            fill: "clear",
                                            color: "danger",
                                            size: "small",
                                            onClick: ($event: any) => (_ctx.deletePdf(p))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "icon-only",
                                                icon: _ctx.trashOutline
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("p", _hoisted_10, "Нет PDF материалов."))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.mediaTab === 'pdf']
          ])
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}